import React from "react";
import ReferredList from "./ReferredList";
import ReferredConsultationList from "./ReferredConsultationList";
export default function ResuableCard({ total }) {
  const INR = (n) =>
    n.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    });
const demoList = [
  {
    _id: "1",
    status: "accepted",
    DoctorName: "Prem Kumar",
    referredTotal: 1500,
    coverPic: "",
    profile: "",
  },
  {
    _id: "2",
    status: "accepted",
    DoctorName: "ram Kumar",
    referredTotal: 1500,
    coverPic: "",
    profile: "",
  },
  {
    _id: "3",
    status: "accepted",
    DoctorName: "kadhir Kumar",
    referredTotal: 1500,
    coverPic: "",
    profile: "",
  }
];
  return (
    <div>
    <div className="rounded-2xl border border-gray-200 bg-white px-4 py-3 shadow-sm dark:border-gray-700 dark:bg-gray-900">
      <p className="text-[11px] uppercase tracking-wider text-gray-500 dark:text-gray-400">
        Total
      </p>
      <p className="text-xl font-semibold text-gray-900 dark:text-gray-100">
        {INR(total)}
      </p>
       </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4">
        <div>
          <ReferredList list={demoList} />
        </div>
        <div>
          <ReferredConsultationList />
        </div>
      </div>
   
    </div>
  );
}
